import { RefundACHTransactionRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useRefundACHTransaction({ bearer }: { bearer?: string }) {
  const [fetching, setFetching] = useState(false);

  async function refundACHTransaction(params: RefundACHTransactionRequest) {
    try {
      setFetching(true);
      const res = await api.postRefundACHTransaction(params, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, refundACHTransaction };
}
